import React from 'react';
import classnames from 'classnames';
import { h5, uppercase } from 'scy/text/styles.mod.scss';
import { bottom_sm } from 'scy/margin.mod.scss';
import { clickable } from 'scy/utils.mod.scss';

export default function FilterItemHeading({ title, onClick, children }) {
  return (
    <div
      className={classnames(bottom_sm, { [clickable]: !!onClick })}
      onClick={onClick}
    >
      <span className={classnames(h5, uppercase)}>{title}</span>
      {children}
    </div>
  );
}
